<template>


    <div class="row column page-content messages-panel collapse">

        <div class="row align-stretch collapse">
            <div class="small-4 column message-thread-list-search">
                <input type="text" class="search inline" placeholder="Meklēt..."
                       v-model="query"/>
            </div>
            <div class="column message-toolbar">
                <button v-if="!showNewMessageForm" type="button" class="button inline" @click="showNewMessageForm = true">Jauna ziņa</button>
                <button v-else type="button" class="button hollow inline" @click="showNewMessageForm = false">Atcelt</button>
            </div>
        </div>

        <div class="row align-stretch collapse">

            <div class="small-4 column message-thread-list">
                <spinner v-if="loadingMessages === true" class="spinner"></spinner>
                <message-list-item v-else-if="user" v-for="m in messages"
                                   class="message-thread-list-item"
                                   :key="m.id"
                                   :avatar="m.sneder_id === user.id ? m.recipient.avatar : m.sender.avatar"
                                   :name="m.sender_id === user.id ? m.recipient.name : m.sender.name"
                                   :date="m.updated_at"
                                   :subject="m.subject"
                                   :seen="m.sender_id === user.id ? m.seen_by_sender : m.seen_by_recipient"
                                   :active="m === selectedMessage"
                                   @click.native="selectedMessage = m"></message-list-item>
            </div>

            <div v-if="showNewMessageForm" class="small-8 column" key="new-message">
                <message-form class="new-message-form" :recipient="recipient" @sent="onSent"></message-form>
            </div>

            <div v-else="" key="message-thread" class="column message-thread-container" id="message-thread-container">
                <message-thread v-if="selectedMessage" :message="selectedMessage" @loaded="setAsSeen"></message-thread>

                <p v-if="messages !== null && messages.length === 0" class="watermark">Šobrīd nav nevienas ziņas</p>
            </div>

        </div>
    </div>

</template>

<script>
    import MessageListItem from '../../components/inbox/MessageListItem'
    import MessageThread from '../../components/inbox/MessageThread'
    import MessageForm from '../../components/inbox/MessageForm'
    import messages from '../../api/messages'
    import { mapGetters } from 'vuex'
    import _ from 'lodash'

    export default {
        created() {
            //TODO implement message view scrolling and sticky date headers
            this.getMessages()
                .then(response => this.selectedMessage = this.messages[0])
        },

        props: {
            recipient: Object,
        },

        data() {
            //TODO Refactor into smaller components
            return {
                showNewMessageForm: false,
                messages: null,
                selectedMessage: null,
                page: 1,
                totalPages: 1,
                totalComments: 0,
                query: null,

                loadingMessages: false,
                loadingMessage: false,
            }
        },

        methods: {
            onSent(message) {
                this.showNewMessageForm = false;
                this.getMessages({ page: 1 });
            },

            getMessages(params) {
                this.loadingMessages = true;
                return messages.get(params)
                    .then(response => {
                        if (response.data.meta.current_page === 1) {
                            this.messages = response.data.data;
                        } else {
                            this.messages = this.messages.concat(response.data.data);
                        }

                        this.page = response.data.meta.current_page;
                        this.totalPages = response.data.meta.last_page;
                        this.totalComments = response.data.meta.total;

                        this.loadingMessages = false;

                        return response;
                    })
            },

            setAsSeen(message) {
                if (this.user.id === message.sender_id && !message.seen_by_sender) {
                    message.seen_by_sender = true;
                    messages.seen(message.id).then(response => this.$store.dispatch('getInboxStats'))
                }

                if (this.user.id === message.recipient_id && !message.seen_by_recipient) {
                    message.seen_by_recipient = true;
                    messages.seen(message.id).then(response => this.$store.dispatch('getInboxStats'))
                }
            },

            onSearch: _.debounce(function () {
                this.getMessages({ query: this.query, page: 1 })
            }, 500),

        },

        computed: {
            ...mapGetters(['user'])
        },

        watch: {
            query: function (val, oldVal) {
                this.onSearch();
            }
        },

        components: {
            MessageListItem, MessageThread, MessageForm
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    $border-color: #e8e8e8;

    .column.page-content.collapse {
        padding: 0;
    }

    .messages-panel {

        .search {
            border-radius: 50px;
        }

        > .row:first-child {
            > .column {
                padding: 1rem;
                border-bottom: none;
            }
        }

        > .row {
            > .column {
                border: 1px solid $border-color;

                &:first-child {
                    margin-right: -1px;
                }
            }
        }
    }

    .message-thread-container {
        overflow-y: auto;
        transform: translateZ(0);
        max-height: 800px;
    }

    .new-message-form {
        padding: 1rem;
    }


</style>


// WEBPACK FOOTER //
// resources/assets/js/views/inbox/InboxMessages.vue